import React from 'react';

import {
    MarketingPreferencesFields
} from '@interlayer/js/app/components/main/MarketingPreferences/components/MarketingPreferencesFields';
import { TermsCheckbox } from '@interlayer/js/app/components/main/Registration/components/fields/PreferencesFields/components/TermsCheckbox';

import style from './PreferencesFields.scss';

export const PreferencesFields: React.FC = () => {
    return (
        <div className={style.container}>
            <MarketingPreferencesFields tSuffix={'registration'} classNames={{ buzzLimited: style.buzzLimited, infoPanel: style.infoPanel }} />

            <TermsCheckbox />
        </div>
    );
};
